<template>
  <div class="statisticalAnalysis" ref="statisticalAnalysis">
    <van-sticky>
      <van-tabs
        v-model="activeName"
        title-active-color="#36B374"
        color="#36B374"
        @click="selectChange"
        class="my-tabs"
      >
        <van-tab title="受理情况" name="受理情况" />
        <van-tab title="区域分析" name="热门区域" />
        <van-tab title="游客分析" name="游客分析" />
      </van-tabs>
    </van-sticky>
    <Acceptance @nodata="tabPaneDataChange()" ref="AcceptanceBox" v-if="activeName === '受理情况' && !nodata" />
    <HotArea @nodata="tabPaneDataChange()" ref="HotAreaBox" v-if="activeName === '热门区域' && !nodata" />
    <VisitorAnalyze @nodata="tabPaneDataChange()" ref="VisitorAnalyzBox" v-if="activeName === '游客分析' && !nodata" />
    <!-- 缺省页面 -->
    <div v-if="nodata" class="nodata">
      <img src="../../../../assets/refund/icon_Noreturn@2x.png" alt="">
      <p class="text">该地区暂时没发生退货</p>
    </div>
    <div class="footer">
      <div class="foot-inner">
        <div class="foot-item"  @click="showPopup('area')">
          <img
            class="left-icon"
            src="../../../../assets/refund/icon_filterLocation@2x.png"
            alt=""
          />
          <span class="text">{{ areaName }}</span>
          <img
            class="right-icon"
            src="../../../../assets/refund/icon_ arrowDown@2x.png"
            alt=""
          />
        </div>
        <div class="foot-item" @click="showPopup('timeArr')">
          <img
            class="left-icon"
            src="../../../../assets/refund/icon_filterTime@2x.png"
            alt=""
          />
          <span class="text">{{ time }}</span>
          <img
            class="right-icon"
            src="../../../../assets/refund/icon_ arrowDown@2x.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <area-popup
      v-model="pageParams.areaId"
      :type="regionType ? 'double' : 'single'"
      :adcode="currentUser ? currentUser.regionCode : ''"
      :isPopup="isPopup"
      @close="isPopup = false"
      @confirm="areaConfirm"
    />
    <time-popup
      v-model="pageParams.timeArr"
      title="申请时间"
      :isPopup="isTimePopup"
      @close="isTimePopup = false"
      @confirm="timeConfirm"
    />
  </div>
</template>

<style lang="less" scoped>
.statisticalAnalysis {
  /deep/.van-sticky--fixed {
        z-index: 100;
  }
  /deep/.my-tabs {
    .van-tab--active {
      font-weight: 600;
    }
    .van-tabs__line {
      width: 18px;
      height: 3px;
      bottom: 19px;
    }
  }
  .nodata {
    height: 77vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      width: 85px;
      height: 85px;
    }
    .text {
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #71747A;
    }
  }
  .footer {
    position: fixed;
    bottom: 28px;
    width: 100%;
    z-index: 99;
    padding: 0 16px;
    .foot-inner {
      padding: 20px 16px;
      display: flex;
      background: #76787a;
      border-radius: 6px;
      .foot-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        .left-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        .text {
          font-size: 16px;
          color: white;
          font-weight: 500;
        }
        .right-icon {
          width: 12px;
          height: 12px;
          margin-left: 5px;
        }
      }

    }
  }
}
</style>

<script>
    import Acceptance from './Acceptance';
    import HotArea from './HotArea';
    import VisitorAnalyze from './VisitorAnalyze';
    import AreaPopup from '../components/areaPopup.vue';
    import TimePopup from '../components/timePopup.vue';
    import API from '@/service/modules/refund';
    import { mapActions, mapGetters } from 'vuex';

    export default {
      name: 'statisticalAnalysis',
        components: { Acceptance, HotArea, VisitorAnalyze, AreaPopup, TimePopup },
        data () {
            return {
                activeName: '受理情况',
                province: '全省',
                areaName: '全省',
                time: '时间',
                isPopup: false,
                isTimePopup: false,
                pageParams: {
                    status: '',
                    pick: '',
                    areaId: '',
                    timeArr: '',
                    startDate: '',
                    endDate: '',
                    pageIndex: 1,
                    pageSize: 10
                },
                regionType: false,
                nodata: false,
                timeArr: [],
                areaCode: '',
                tabsChange: false,
                tabPanescrolltop: {
                  AcceptanceBox: 0,
                  HotAreaBox: 0,
                  VisitorAnalyzBox: 0,
                },
            };
        },
        created () {
            API
                .currentUser()
                .then((res) => {
                    if (res.ret == 0 && res.data) {
                        let regionType = res.data.regionType
                        this.province = res.data.regionName
                        this.areaName = this.province;
                        this.pageParams.areaId = res.data.regionCode
                        this.$store.state.refund.statisticalAnalysisReginCode = res.data.regionCode
                        this.regionCode = res.data.regionCode
                        if (regionType == '3') {
                            this.regionType = false
                        } else {
                            this.regionType = true
                        }
                    }
                })
            this.init();
        },
        mounted() {
          // window.addEventListener('scroll', this.handleScroll)
        },
        computed: {
            ...mapGetters('refund', {
                currentUser: 'getCurrentUser', // 当前用户信息
                isRegulatoryUser: 'isRegulatoryUser' // 是否是监管者权限
            })
        },
        beforeRouteLeave(to, from, next) {
          // if (to.path === '/refund/newRefund') {
          //   this.$store.state.refund.statisticalAnalysisTime.startTime = ''
          //   this.$store.state.refund.statisticalAnalysisTime.endTime = ''
          //   this.$store.state.refund.statisticalAnalysisReginCode = 0
          // }
          // from.meta.keepAlive = (["/refund/allCounty", '/refund/commonList', '/refund/cityAreaRefundList'].includes(to.path))
          
          console.log('离开分析');
          const routerArr = ['/refund/cityAreaRefundList', '/refund/commonList', '/refund/allCounty']
          if (!routerArr.includes(to.path)) {
          // 不在缓存列表中，从cachedViews缓存列表中移除
            this.$store.commit('refund/DEL_CACHED_VIEW', from)
          } else {
            this.$store.commit('refund/ADD_CACHED_VIEW', from)
          }
          
          next()
        },
        methods: {
            ...mapActions('refund', {
                setCurrentUser: 'setCurrentUser'
            }),
            // handleScroll() {
            //   if (this.activeName == '游客分析') {
                
            //     this.tabPanescrolltop.VisitorAnalyzBox = document.documentElement.scrollTop
            //     console.log('游客分析滚动', this.tabPanescrolltop.VisitorAnalyzBox);
            //     } else if (this.activeName == '热门区域') {
                  
            //       this.tabPanescrolltop.HotAreaBox = document.documentElement.scrollTop
            //       console.log('热门区域滚动', this.tabPanescrolltop.HotAreaBox);
            //     } else if (this.activeName == '受理情况') {
                  
            //       this.tabPanescrolltop.AcceptanceBox = document.documentElement.scrollTop
            //       console.log('受理情况滚动', this.tabPanescrolltop.AcceptanceBox);
            //     }
            // },
            tabPaneDataChange(nodata) {
              this.nodata = nodata
            },
            async init () {
                this.currentUser || (await this.setCurrentUser());
            },
            areaConfirm (label, code, regionType) {

              console.log('areaConfirm', code);
              this.areaCode = code
                this.areaName = label;
                if (this.activeName == '游客分析') {
                    this.$refs.VisitorAnalyzBox.areaChange(code)
                } else if (this.activeName == '热门区域') {
                    this.$refs.HotAreaBox.areaChange(code)
                    this.$refs.HotAreaBox.queryType = regionType
                } else if (this.activeName == '受理情况') {
                    this.$refs.AcceptanceBox.areaChange(code)
                }
                  this.tabsChange = !this.tabsChange

            },
            timeConfirm (label, timeArr) {

              console.log('timeConfirm', label);
                this.time = label;
                this.timeArr = timeArr

                if (this.activeName == '游客分析') {
                    this.$refs.VisitorAnalyzBox.timeChange(timeArr)
                } else if (this.activeName == '热门区域') {
                  this.$refs.HotAreaBox.timeChange(timeArr)

                } else if (this.activeName == '受理情况') {
                    this.$refs.AcceptanceBox.timeChange(timeArr)

                }
                  this.tabsChange = !this.tabsChange

            },
            showPopup (e) {
                if (e == 'timeArr') {
                    this.isTimePopup = true;
                } else if (e == 'area') {
                    if (!this.regionType) {
                        this.isPopup = false
                    } else {
                        this.isPopup = true
                    }
                }
            },
            selectChange (value) {
                // this.time = '时间';
                // this.areaName = this.province;
                  // this.$nextTick(() => {
                  //   this.areaConfirm(this.areaName, this.areaCode)
                  //   this.timeConfirm(this.time, this.timeArr)
                  // })
                this.nodata = false
                // if (value == '游客分析') {
                //   document.documentElement.scrollTop = this.tabPanescrolltop.VisitorAnalyzBox
                // } else if (value == '热门区域') {
                //   document.documentElement.scrollTop = this.tabPanescrolltop.HotAreaBox
                // } else if (value == '受理情况') {
                //   document.documentElement.scrollTop = this.tabPanescrolltop.AcceptanceBox
                // }
                document.documentElement.scrollTop && (document.documentElement.scrollTop = 0)
                document.body.scrollTop && (document.body.scrollTop = 0)
            }
        }
    };
</script>
